import { ActiveJob } from '@assets/component/ActiveJob/ActiveJob';
import { useStore, useStoreUI } from '@assets/model/Store';
import { observer } from 'mobx-react';
import {
    Route,
    BrowserRouter as Router,
    Routes,
    useLocation
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import DealDBPage from './DealDBPage';
import DealView from './DealView';
import LoginPage from './Login';
import { Loading } from '@assets/component/Loading/Loading';
import { useEffect } from 'react';
import { useNavUtils } from '@assets/utils/NavUtils';
import KnowledgeBase from './KnowledgeBase';

export const PageFrame = observer(() => {
    const store = useStore();

    useEffect(() => {
        document.addEventListener('visibilitychange', function () {
            if (document.hidden) {
                const storeUI = useStoreUI();
                storeUI.onKeyUpReset();
            }
        });

        document.addEventListener('keydown', e => {
            const storeUI = useStoreUI();

            //key for back?
            if (e.key === 'Backspace') {
                if (
                    (e.currentTarget as any).activeElement.localName == 'input'
                ) {
                    return;
                }
                window.history.back();
            }

            if (e.ctrlKey) {
                storeUI.isKeyControlKeyDown = true;
            }

            if (e.key === 'PageUp') {
                storeUI.scrolling = 'UP';
            } else if (e.key === 'PageDown') {
                storeUI.scrolling = 'DOWN';
            } else {
                storeUI.scrolling = 'NONE';
            }

            if (e.key == 'Tab') {
                if (
                    (e.currentTarget as any).activeElement.localName == 'input'
                ) {
                    return;
                }
                e.preventDefault();
                storeUI.isKeyShiftKeyDown = e.shiftKey;
                storeUI.isKeyTabDown = true;
            }

            if (e.key == 'Escape') {
                e.preventDefault();
                storeUI.isKeyEscapeDown = true;
            }
        });

        document.addEventListener('keyup', e => {
            const storeUI = useStoreUI();
            storeUI.onKeyUpReset();
        });
    }, []);

    const hrefContainsLogin = window.location.href.includes('/login');
    return (
        <>
            <ToastContainer
                position="bottom-right"
                style={{
                    zIndex: 100000000,
                    textAlign: 'right'
                }}
            />
            <ActiveJob />

            <Loading />

            <Router>
                <Routes>
                    <Route
                        path="/"
                        element={store.isLoaded ? <DealDBPage /> : null}
                    />
                    {/* <Route path="/chat" element={<ChatUI />} /> */}
                    <Route path="/login" element={<LoginPage />} />
                    <Route
                        path="/:id"
                        element={store.isLoaded ? <DealView /> : null}
                    />
                    <Route
                        path="/knowledge"
                        element={store.isLoaded ? <KnowledgeBase /> : null}
                    />
                </Routes>
            </Router>
        </>
    );
});
